function NgTokenConfig($authProvider, AppSettings) {
  'ngInject';
  // the following shows the default values. values passed to this method
  // will extend the defaults using angular.extend

  $authProvider.configure({
    apiUrl:                  AppSettings.apiUrl,
    tokenValidationPath:     '/auth/validate_token',
    signOutUrl:              '/auth/sign_out',
    passwordResetPath:       '/auth/password',
    passwordUpdatePath:      '/auth/password',
    passwordResetSuccessUrl: window.location.href,
    emailSignInPath:         '/auth/sign_in',
    storage:                 'localStorage',
    forceValidateToken:       false,

    tokenFormat: {
      "access-token": "{{ token }}",
      "token-type":   "Bearer",
      "client":       "{{ clientId }}",
      "expiry":       "{{ expiry }}",
      "uid":          "{{ uid }}"
    },
    cookieOps: {
      path: "/",
      expires: 9999,
      expirationUnit: 'days',
      secure: false,
      domain: window.location.href
    },
    createPopup: function(url) {
      return window.open(url, '_blank', 'closebuttoncaption=Cancel');
    },
    parseExpiry: function(headers) {
      // convert from UTC ruby (seconds) to UTC js (milliseconds)
      return (parseInt(headers['expiry']) * 1000) || null;
    },
    handleLoginResponse: function(response) {
      return response.data;
    },
    handleAccountUpdateResponse: function(response) {
      return response.data;
    },
    handleTokenValidationResponse: function(response) {
      return response.data;
    }
  });

}

export default NgTokenConfig;
